module.exports = ".software {\n  margin-top: 20px; }\n"


//////////////////
// WEBPACK FOOTER
// ./libs/atenea-cms-brand/src/products/product-software-form/product-software-form.component.scss
// module id = ./libs/atenea-cms-brand/src/products/product-software-form/product-software-form.component.scss
// module chunks = main